import UserService from "../office/userService";

class UserHandler {
  static async searchByQuery(query) {
    try {
      const data = await UserService.getUsersByQuery( query );
      return data?.data?.Users ?? [];
    } catch (error) {
      console.error("Error in getUserByName use case:", error);
      return [];
    }
  }
}

export default UserHandler;